module.exports = __webpack_public_path__ + "assets/img/yingni.9b4a6e5b.png";